import styled from 'styled-components';
import { createColumnHelper } from '@tanstack/react-table';
import { RoleGetResult, UserProfileResult } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { ColumnFilterType, Body } from '@optimus-web/core';
import { RemoveUserCell } from './RemoveUserCell';

interface UseColumnsOptions {
    role: RoleGetResult;
    onRowDelete: (id: string) => void;
}

const ParagraphWithMaxWidth = styled(Body)<{ maxWidth: number }>`
    max-width: ${(props) => props.maxWidth}px;
`;

const columnHelper = createColumnHelper<UserProfileResult>();

export const useColumns = ({ role, onRowDelete }: UseColumnsOptions) => [
    columnHelper.accessor('fullName', {
        id: 'name',
        header: () => <LocalizedText textKey={TextKey.Name} />,
        cell: (props) => {
            const value = props.getValue();
            return value ? (
                <ParagraphWithMaxWidth ellipsis maxWidth={157} size="small">
                    {value}
                </ParagraphWithMaxWidth>
            ) : (
                UnicodeEntity.Dash
            );
        },
        enableColumnFilter: true,
        enableSorting: true,
        meta: { filtersType: ColumnFilterType.String },
    }),
    columnHelper.accessor('email', {
        header: () => <LocalizedText textKey={TextKey.Email} />,
        cell: (props) => {
            const value = props.getValue();
            return value ? (
                <ParagraphWithMaxWidth ellipsis maxWidth={157} size="small">
                    {value}
                </ParagraphWithMaxWidth>
            ) : (
                UnicodeEntity.Dash
            );
        },
        enableColumnFilter: true,
        enableSorting: true,
        meta: { filtersType: ColumnFilterType.String },
    }),
    columnHelper.accessor('departments', {
        id: 'department',
        header: () => <LocalizedText textKey={TextKey.Department} />,
        cell: (props) => {
            const value = props.getValue();
            return value ? (
                <ParagraphWithMaxWidth ellipsis maxWidth={100} size="small">
                    {value}
                </ParagraphWithMaxWidth>
            ) : (
                UnicodeEntity.Dash
            );
        },
        enableSorting: true,
    }),
    columnHelper.display({
        id: 'actions',
        meta: { width: 64, align: 'end' },
        cell: (props) => (
            <RemoveUserCell
                role={role}
                userId={props.row.original.userId}
                isProvisioned={props.row.original.isScimProvisioned}
                onDelete={() => onRowDelete(props.row.original.userId)}
            />
        ),
    }),
];
